import { useSelector } from "react-redux"
import useReturnVideoRecorder from "../../hooks/useReturnVideoRecorder"
import useCameraPreview from "../../hooks/useCameraPreview"
import { isRecording as selectReturnIsRecording } from "../../redux/returnVideoRecorderSlice"

// Mounted only when the warehouse has requires_return_camera on. Owns the recorder
// hook and the live preview, so the camera/permission prompt is never triggered for
// warehouses that don't use return video. Recording itself is still driven by the
// redux isRecording flag set on the receive screen's first part.
export const ReturnCameraRecorder = () => {
  useReturnVideoRecorder()
  const { videoRef, isReady } = useCameraPreview()
  const recording = useSelector(selectReturnIsRecording)

  return (
    <video
      ref={videoRef}
      autoPlay
      muted
      playsInline
      data-ready={isReady ? "true" : "false"}
      style={{
        position: "fixed",
        // Sits above the receive screen's bottom action bar so it never covers Save.
        bottom: 96,
        right: 16,
        width: 180,
        borderRadius: 8,
        zIndex: 50,
        backgroundColor: "#000",
        border: recording ? "2px solid #ef4444" : "2px solid transparent",
      }}
    />
  )
}

export default ReturnCameraRecorder
